import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import AboutView from '@/views/AboutView.vue'
import LoginView from '@/views/LoginView.vue'
import UsersView from '@/views/UsersView.vue'
import FacebookAccountsView from '@/views/FacebookAccountsView.vue'
import FacebookCallbackView from '@/views/FacebookCallbackView.vue'
import FacebookConversionsView from '@/views/FacebookConversionsView.vue'

const routes = [
  { path: '/', name: 'home', component: HomeView, meta: { requiresAuth: true } },
  { path: '/login', name: 'login', component: LoginView },
  { path: '/about', name: 'about', component: AboutView },
  { path: '/admin/users', name: 'admin-users', component: UsersView, meta: { requiresAuth: true, requiresAdmin: true } },
  { path: '/facebook-accounts', name: 'facebook-accounts', component: FacebookAccountsView, meta: { requiresAuth: true } },
  { path: '/facebook-conversions', name: 'facebook-conversions', component: FacebookConversionsView, meta: { requiresAuth: true } },
  { path: '/facebook/callback', name: 'facebook-callback', component: FacebookCallbackView }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Глобальный guard для защиты маршрутов
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
  if (to.meta.requiresAuth && !token) {
    next({ name: 'login' })
  } else if (to.meta.requiresAdmin && (!user || user.role !== 'admin')) {
    next({ name: 'home' })
  } else {
    next()
  }
})

export default router